export default __webpack_public_path__ + "ab7ba8e1b7418cb15b662e533fd2c537.png";